import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';

@Component({
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.pug',
  styleUrls: ['./image-upload.component.scss'],
  standalone: false
})
export class ImageUploadComponent implements OnInit, OnChanges {

  @Input() avatar: any;
  @Output() imageUpdate = new EventEmitter();
  @ViewChild("fileUpload", {static: false}) fileUpload: any;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.avatar === '' && this.fileUpload !== undefined) {
      this.fileUpload.nativeElement.value = "";
    }
  }

  ngOnInit(): void {
  }

  handleFileInput(event) {
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageUpdate.emit({'file': file, 'avatar': reader.result as string, 'filename': file.name});
      };
    }
  }
}
